import React from 'react';
import ReactDOM from 'react-dom';
import View from './passwordLogin/View.jsx';

export default ({
  element,
  props,
}) => {
  ReactDOM.render(
    <View {...props} />,
    element
  );
};
